import React, { useState } from 'react';
import CustomModal from '../Modal/CustomModal';
import { customSwal } from '../CustomSwal';
import axios from 'axios';

const AdminCreateConsoleModal = ({ isOpen, onClose, selectedUser, userInfo, onSuccess }) => {
  const [consoleTitle, setConsoleTitle] = useState('');
  const [loading, setLoading] = useState(false);

  const handleCreateConsole = async () => {
    if (!consoleTitle.trim()) {
      customSwal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Please enter a console title',
      });
      return;
    }

    try {
      setLoading(true);
      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      await axios.post(
        '/api/consoles',
        { title: consoleTitle, ownerId: selectedUser._id },
        config
      );

      setLoading(false);
      customSwal.fire({
        icon: 'success',
        title: 'Success',
        text: `Console "${consoleTitle}" created successfully for ${selectedUser.username}`,
      });
      setConsoleTitle('');
      onClose();
      onSuccess();
    } catch (error) {
      setLoading(false);
      customSwal.fire({
        icon: 'error',
        title: 'Error',
        text: error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
      });
    }
  };

  const handleClose = () => {
    setConsoleTitle('');
    onClose();
  };

  return (
    <CustomModal
      isOpen={isOpen}
      onClose={handleClose}
      title="Create New Console"
      onConfirm={handleCreateConsole}
      confirmText="Create"
      loading={loading}
    >
      <div>
        <label className="block mb-2 font-medium">Console Title:</label>
        <input
          type="text"
          className="w-full p-2 rounded bg-gray-700 text-white"
          value={consoleTitle}
          onChange={(e) => setConsoleTitle(e.target.value)}
          placeholder="Enter console title"
        />
      </div>
    </CustomModal>
  );
};

export default AdminCreateConsoleModal;